export const MobileMenuController = () => {

  $('.toggle-menu').click((e) => {
    $('.js-mobile-menu').slideToggle();
  });

  $('.js-close').click((e) => {
    $('.js-mobile-menu').slideToggle();
  });
}




// WEBPACK FOOTER //
// ./src/js/controllers/MobileMenuController.js